import type { SignOutHooksApi } from '@platform/plugin-platform-react';

/** Durée maximale d'attente des crochets avant de laisser la déconnexion se faire. */
const RUN_ALL_TIMEOUT_MS = 3000;

/** Registre en mémoire des actions à exécuter avant la déconnexion. */
export class SignOutHooksClient implements SignOutHooksApi {
  private readonly hooks = new Set<() => Promise<void>>();

  register(hook: () => Promise<void>): () => void {
    this.hooks.add(hook);
    return () => {
      this.hooks.delete(hook);
    };
  }

  async runAll(): Promise<void> {
    // allSettled : un crochet qui échoue (réseau, 500) ne doit ni bloquer les
    // autres ni empêcher la déconnexion. La course contre un délai borne aussi
    // un crochet qui ne répond jamais : la déconnexion attend 3 s au plus.
    let minuteur: ReturnType<typeof setTimeout> | undefined;
    const delai = new Promise<void>(resolve => {
      minuteur = setTimeout(resolve, RUN_ALL_TIMEOUT_MS);
    });
    try {
      await Promise.race([
        Promise.allSettled([...this.hooks].map(hook => hook())),
        delai,
      ]);
    } finally {
      clearTimeout(minuteur);
    }
  }
}
